import ExcelUpload from '../../components/Reusable/Form/ExcelUpload'
import APIS from '../../constant/EndPoint'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import { uploadOrderExcelFileValidationForm } from '../../utils/validationSchema'
import Card from '../Reusable/Card'
import Button from '../Reusable/Button'
import ImportPreviewDataTable from './ImportPreviewDataTable'
import NACell from '../Reusable/DataTable/NACell'
import { useEffect } from 'react'

const OrderBulkUpload = (props: any) => {
  const { handleFileUpload, inValidOrders, validOrders, openPreviewData, setOpenPreviewData, handleCommitValidOrders, isUploading, userProfileType, isFileUploading } = props


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    resolver: yupResolver(uploadOrderExcelFileValidationForm),
  });

  const columns: any = [
    {
      header: "S.N",
      accessorKey: "serial_number",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Pickup Branch",
      accessorKey: "pickup_branch",
      cell: NACell,
    },
    {
      header: "Destination Branch",
      accessorKey: "destination_branch",
      cell: NACell,
    },
    {
      header: "Customer Name",
      accessorKey: "customer_name",
      cell: NACell,
    },
    {
      header: "Customer Address",
      accessorKey: "customer_address",
      cell: NACell,
    },
    {
      header: "Customer Primary Contact",
      accessorKey: "customer_primary_contact",
      cell: NACell,
    }, {
      header: "Customer Secondary Contact",
      accessorKey: "customer_secondary_contact",
      cell: NACell,
    }, {
      header: "Weight",
      accessorKey: "weight",
      cell: NACell,
    }, {
      header: "COD",
      accessorKey: "cod",
      cell: NACell,
    }, {
      header: "Delivery Charge",
      accessorKey: "delivery_charge",
      cell: NACell,
    }, {
      header: "Delivery Instruction",
      accessorKey: "delivery_instruction",
      cell: NACell,
    },
  ];

  useEffect(() => {
    setOpenPreviewData(false)
  }, [watch("file"), watch("merchant")])


  return (
    <>

      <form onSubmit={handleSubmit((data: any) => handleFileUpload(data, setError))} autoComplete="off">
        <Card>
          <ComboboxInput
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("merchant", {
              required: "Merchant is required",
            })}
            errors={errors?.merchant}
            name={"merchant"}
            label={"Merchant"}
            setValue={setValue}
            placeholder={"Search Vendor/Merchant"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </Card>
        <ExcelUpload
          register={register("file")}
          errors={errors}
          handleOnChange={handleFileUpload}
          url={APIS.ORDER}
          fileName={"order-sample-data"}
          watch={watch}
          setError={setError}
        />
        <div className="flex justify-end w-full">
          <div className="w-[100px] mr-4">
            <Button label={"Upload"} isLoading={isFileUploading} />
          </div>
        </div>
      </form>
      {openPreviewData &&
        <>
          <ImportPreviewDataTable title="Invalid Data" data={inValidOrders} columns={columns} isSubmit={false} handleSubmit={handleCommitValidOrders} isUploading={isUploading} />
          <ImportPreviewDataTable title="Valid Data" data={validOrders} columns={columns} isSubmit={true} handleSubmit={handleCommitValidOrders} isUploading={isUploading} />
        </>
      }
    </>

  )
}

export default OrderBulkUpload
